import {
  DELETE_RENOVATION_AND_REFURBISHMENT_WORKS,
  GET_RENOVATION_AND_REFURBISHMENT_WORKS,
  POST_RENOVATION_AND_REFURBISHMENT_WORKS,
  PUT_RENOVATION_AND_REFURBISHMENT_WORKS,
} from "../constants/actionTypes";

const defaultState = {};
let index = "";

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_RENOVATION_AND_REFURBISHMENT_WORKS:
        return { ...action.payload };
      case POST_RENOVATION_AND_REFURBISHMENT_WORKS:
        return { ...state, ...action.payload };
      case PUT_RENOVATION_AND_REFURBISHMENT_WORKS:
        return { ...state, ...action.payload };
      case DELETE_RENOVATION_AND_REFURBISHMENT_WORKS:
        return [...state.filter((data) => data?.id != action?.payload)];
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
